
import { Component, Prop, Vue } from "vue-property-decorator";
import { plainToInstance } from "class-transformer";

import userRoutes from "@/api/routes/users";

import Preloader from "@/components/Preloader.vue";
import CUserEdit from "@/components/user/UserEdit.vue";
import CCalendar from "@/components/calendar/Calendar.vue";
import CEducations from "@/components/user/Educations.vue";

import CTeamTesting from "@/views/team/components/testing/Testing.vue";
import CTasks from "@/views/team/components/Tasks.vue";

import UserUser from "@/models/user/user";
import { EAdmissionPermission } from "@/models/admission/permission";

import CTeamLearningPrograms from "./components/programs/LearningPrograms.vue";
import CTeamUnscheduledPrograms from "./components/programs/UnscheduledPrograms.vue";
import CTeamPriority from "./components/Priority.vue";
import CTeamAkt from "./components/Akt.vue";
import CTeamSkillConfirmations from "./components/SkillConfirmations.vue";
import { IRouteMeta } from "@/router/interface";

@Component({
  name: "VTeammate",
  components: {
    Preloader,
    CUserEdit,
    CCalendar,
    CEducations,
    CTeamTesting,
    CTasks,
    CTeamLearningPrograms,
    CTeamUnscheduledPrograms,
    CTeamPriority,
    CTeamAkt,
    CTeamSkillConfirmations
  }
})
export default class VTeamOne extends Vue {
  @Prop({ required: true }) public user_id!: string;

  public preload: boolean = false;

  public show_modal: boolean = false;

  public teammate: UserUser | null = null;

  public tabs: Array<{ id: string; value: string; badge: number }> = [
    { id: "programs", value: "Обязательное обучение", badge: 0 },
    { id: "programs_unscheduled", value: "Внеплановое обучение", badge: 0 },
    { id: "education", value: "Внешнее обучение", badge: 0 },
    { id: "calendar", value: "Календарь обучения", badge: 0 },
    { id: "skills", value: "Навыки", badge: 0 },
    { id: "priority", value: "Приоритеты", badge: 0 },
    { id: "task", value: "Практические/Индивидуальные задания", badge: 0 },
    { id: "testing", value: "Тесты", badge: 0 }
  ];
  public current_tab = this.tabs[0];

  $refs!: {
    tabs: HTMLDivElement;
  };

  protected async created() {
    this.preload = true;

    if (this.hasAktPermissions()) {
      this.tabs.push({ id: "act", value: "Назначение ЕПЗ", badge: 0 });
    }

    await Promise.all([this.loadUnconfirmedEvents(), this.loadUser()]).finally(
      () => (this.preload = false)
    );
  }

  private async loadUser() {
    return this.$api
      .get(userRoutes.user(this.user_id), {
        params: {
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: UserUser }) => {
        this.teammate = plainToInstance(UserUser, res);
      });
  }

  private async loadUnconfirmedEvents() {
    return this.$api
      .get(userRoutes.unconfirmedEvents(this.user_id), {
        params: {
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: { count: number } }) => {
        this.tabs.find(i => i.id === "calendar")!.badge = res.count;
      });
  }

  public openModal() {
    this.show_modal = true;
  }

  public closeModal(data: { user: UserUser }) {
    this.teammate = data.user;

    this.show_modal = false;
  }

  public changeTab(tab_idx: number) {
    this.current_tab = this.tabs[tab_idx];
  }

  public tabScrollRight() {
    this.$refs.tabs.scrollLeft += 100;
  }

  public tabScrollLeft() {
    this.$refs.tabs.scrollLeft -= 100;
  }

  private hasAktPermissions() {
    return this.$api.hasWritePermissions([
      EAdmissionPermission.AKT_COMPLETED,
      // EAdmissionPermission.AKT_QUESTIONS,
      EAdmissionPermission.AKT_SETTINGS,
      EAdmissionPermission.AKT_TEMPLATES
    ]);
  }
}
